module.exports = __webpack_public_path__ + "static/media/artist-pre-production.bb7a53f8.jpg";